import { gql } from '@apollo/client';

export const GET_FILES_BY_TALENT = gql`
    query GetFilesByTalent($talentId: ID!, $context: String, $limit: Int, $offset: Int, $search: String) {
        getFilesByTalent(talentId: $talentId, context: $context, limit: $limit, offset: $offset, search: $search) {
            files {
                _id
                name
                path
                context
                size
                url
                thumbnailUrl
                mimetype
                talentId
                proId
                upercutId
                createdBy {
                    _id
                    role
                    avatarUrl
                }
                createdAt
                updatedAt
            }
            total
            hasMore
        }
    }
`;

export const GET_FILES_BY_TALENT_UPERCUT = gql`
  query GetFilesByTalentUpercut($talentId: ID!, $context: String, $limit: Int, $offset: Int, $search: String) {
    getFilesByTalentUpercut(talentId: $talentId, context: $context, limit: $limit, offset: $offset, search: $search) {
      files {
        _id
        name
        path
        context
        size
        url
        thumbnailUrl
        mimetype
        talentId
        proId
        upercutId
        createdBy {
          _id
          role
          avatarUrl
        }
        createdAt
        updatedAt
      }
      total
      hasMore
    }
  }
`;

export const ADD_FILE_FOR_TALENT = gql`
    mutation AddFileForTalent($file: Upload!, $talentId: ID!, $context: String) {
        addFileForTalent(file: $file, talentId: $talentId, context: $context) {
            _id
            name
            path
            context
            size
            url
            thumbnailUrl
            mimetype
            talentId
            proId
            upercutId
            createdBy {
                _id
                role
                avatarUrl
            }
            createdAt
            updatedAt
        }
    }
`;

export const ADD_FILE_FOR_TALENT_UPERCUT = gql`
  mutation AddFileForTalentUpercut($file: Upload!, $talentId: ID!, $context: String) {
    addFileForTalentUpercut(file: $file, talentId: $talentId, context: $context) {
      _id
      name
      path
      context
      size
      url
      thumbnailUrl
      mimetype
      talentId
      proId
      upercutId
      createdBy {
        _id
        role
        avatarUrl
      }
      createdAt
      updatedAt
    }
  }
`;

export const ADD_FILES_FOR_TALENT = gql`
    mutation AddFilesForTalent($files: [Upload]!, $talentId: ID!, $context: String) {
        addFilesForTalent(files: $files, talentId: $talentId, context: $context) {
            _id
            name
            path
            context
            size
            url
            thumbnailUrl
            mimetype
            talentId
            proId
            upercutId
            createdBy {
                _id
                role
                avatarUrl
            }
            createdAt
            updatedAt
        }
    }
`;

export const ADD_FILES_FOR_TALENT_UPERCUT = gql`
  mutation AddFilesForTalentUpercut($files: [Upload]!, $talentId: ID!, $context: String) {
    addFilesForTalentUpercut(files: $files, talentId: $talentId, context: $context) {
      _id
      name
      path
      context
      size
      url
      thumbnailUrl
      mimetype
      talentId
      proId
      upercutId
      createdBy {
        _id
        role
        avatarUrl
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_FILES_COUNT_BY_TALENTS = gql`
    query GetFilesCountByTalents($talentIds: [ID]!, $context: String) {
        getFilesCountByTalents(talentIds: $talentIds, context: $context) {
            talentId
            fileCount
        }
    }
`;

export const GET_FILES_COUNT_BY_TALENTS_UPERCUT = gql`
  query GetFilesCountByTalentsUpercut($talentIds: [ID]!, $context: String) {
    getFilesCountByTalentsUpercut(talentIds: $talentIds, context: $context) {
      talentId
      fileCount
    }
  }
`;

export const DOWNLOAD_ALL_FILES_BY_TALENT = gql`
    query DownloadAllFilesByTalent($talentId: ID!, $context: String, $search: String) {
        downloadAllFilesByTalent(talentId: $talentId, context: $context, search: $search) {
            url
        }
    }
`;

export const DOWNLOAD_ALL_FILES_BY_TALENT_UPERCUT = gql`
  query DownloadAllFilesByTalentUpercut($talentId: ID!, $context: String, $search: String) {
    downloadAllFilesByTalentUpercut(talentId: $talentId, context: $context, search: $search) {
      url
    }
  }
`;

export const FILE_FRAGMENT = gql`
  fragment fileFragment on File { 
    _id
    name
    path
    size
    context
    url
    mimetype
    upercutId
  }
`;

export const DOWNLOAD_FILE = gql`
  query DownloadFile($_id: ID!) {
    downloadFile(_id: $_id) {
      url
    }
  }
`;

export const DOWNLOAD_FILE_BY_KEY = gql`
  query DownloadFileByKey($key: String!, $isPrivate: Boolean!) {
    downloadFileByKey(key: $key, isPrivate: $isPrivate) {
      url
    }
  }
`;

export const ADD_FILE = gql`
  ${FILE_FRAGMENT}
  mutation addFile($file: Upload!, $context: String) {
    addFile(file: $file, context: $context) {
      ...fileFragment
    }
  }
`

export const ADD_FILES = gql`
  ${FILE_FRAGMENT}
  mutation addFiles($files: [Upload]!, $context: String) {
    addFiles(files: $files, context: $context) {
      ...fileFragment
    }
  }
`;

export const DELETE_FILE = gql`
  ${FILE_FRAGMENT}
  mutation deleteFile($_id: ID!) {
    deleteFile(_id: $_id) {
      ...fileFragment
    }
  }
`;

export const DELETE_FILES = gql`
  ${FILE_FRAGMENT}
  mutation deleteFiles($_ids: [ID]!) {
    deleteFiles(_ids: $_ids) {
      ...fileFragment
    }
  }
`;

export const DELETE_FILES_FOR_TALENT_UPERCUT = gql`
  ${FILE_FRAGMENT}
  mutation deleteFilesForTalentUpercut($_ids: [ID]!, $talentId: ID!) {
    deleteFilesForTalentUpercut(_ids: $_ids, talentId: $talentId) {
      ...fileFragment
    }
  }
`;
